/**
 * Formats a dollar amount as a lump sum string with no trailing zeros for
 * whole numbers — e.g. $200 (not $200.00), $150.50 (when fractional).
 * Mirrors the backend's `format_lump_sum` Ruby helper.
 */
export function formatLumpSumAmount(dollars: number): string {
  return dollars === Math.floor(dollars)
    ? `$${Math.floor(dollars)}`
    : `$${dollars.toFixed(2)}`;
}

type TierOption = {
  label: string;
  payRate: number;
};

/**
 * Builds the display label for a tier option in the rate override dropdown.
 * When lump sum is enabled the total shift value is shown; otherwise the
 * hourly rate is shown.
 *
 * Example outputs:
 *   displayAsLumpSum=true,  shiftDuration=4 → "Tier 1 - $200/shift"
 *   displayAsLumpSum=false                  → "Tier 1 - $50.00/hr"
 */
export function formatTierOptionLabel(
  tier: TierOption,
  displayAsLumpSum: boolean,
  shiftDuration: number
): string {
  if (displayAsLumpSum) {
    return `${tier.label} - ${formatLumpSumAmount(tier.payRate * shiftDuration)}/shift`;
  }
  return `${tier.label} - $${tier.payRate.toFixed(2)}/hr`;
}
